<template>
<router-view></router-view>
  </template>
  
  <script>
  export default {
    name: "MatrixPage"
  };
  </script>
  
  <style scoped>
  /* 添加样式 */
  </style>
  